import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import "./../styles/styles.css"; 

function ForgotPassword() {
  const [email, setEmail] = useState('');
  // Message de succès sécurisé (pour ne pas indiquer si l'email existe ou non)
  const [successMessage, setSuccessMessage] = useState(''); 
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const API_URL = process.env.REACT_APP_API_URL; // Utilisation de la variable d'environnement

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');
    setLoading(true);

    if (!email) {
      setError('Veuillez entrer votre adresse email.');
      setLoading(false);
      return;
    }

    try {
      // Lancement de l'action d'envoi du mot de passe oublié vers l'API
      const response = await fetch(`${API_URL}/auth/forgot-password.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      // L'API PHP est censée répondre avec 200/succès pour des raisons de sécurité 
      // (même si l'utilisateur n'existe pas), pour empêcher l'énumération des utilisateurs.
      // On affiche donc le message de succès générique dans tous les cas où la requête HTTP est OK.
      if (!response.ok && response.status !== 400) {
           throw new Error('Problème de connexion au service de réinitialisation.');
      }
      
      console.log('Demande de réinitialisation envoyée pour:', email);
      
      // Affichage du message de succès sécurisé
      setSuccessMessage(
        "Si l'adresse email est associée à un compte, vous recevrez un lien de réinitialisation par email."
      );
      setEmail(''); // Vider le champ 
      
    } catch (err) {
      console.error('Erreur API ou réseau :', err);
      setError('Impossible de se connecter au serveur. Veuillez réessayer plus tard.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h2>Mot de passe oublié</h2>
        <p className="login-subtitle">Entrez votre adresse email ci-dessous pour recevoir un lien de réinitialisation.</p>
        
        {/* Affichage conditionnel : Succès ou Formulaire */}
        {successMessage ? (
            <div className="success-message" style={{ color: 'green', marginBottom: '20px' }}>
                {successMessage}
            </div>
        ) : (
            // Formulaire visible uniquement si le message de succès n'est pas affiché
            <form onSubmit={handleSubmit}>
              <div className="input-group">
                <label htmlFor="email">Email :</label>
                <input
                  type="email"
                  id="email"
                  placeholder="Votre adresse email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="login-input"
                  required
                />
              </div>
              
              {error && <p className="error-message">{error}</p>}
              
              <button type="submit" className="login-button" disabled={loading}>
                {loading ? 'Envoi...' : "Recevoir le lien"}
              </button>
            </form>
        )}
        
        <div className="login-links">
          <Link to="/login">Retour à la connexion</Link>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;